import { IBreadcrumbItem } from '../../../components/Breadcrumbs/Breadcrumbs';

import { PostsType } from './constants';

export const getBlogBreadcrumbs = (type: PostsType, title: string): IBreadcrumbItem[] => {
  switch (type) {
    case 'species':
      return [
        { label: 'All posts', link: '/blog' },
        { label: 'Species posts', link: '/blog/species' },
        { label: title },
      ];
    case 'category':
      return [
        { label: 'All posts', link: '/blog' },
        { label: 'Categories', link: '/blog/categories' },
        { label: title },
      ];
    case 'author':
      return [
        { label: 'All posts', link: '/blog' },
        { label: 'Contributors', link: '/blog/authors' },
        { label: title },
      ];
    default:
      return [{ label: 'All posts', link: '/blog' }, { label: title }];
  }
};
